module.exports = __webpack_public_path__ + "img/battery-slash.fd80af5f.svg";